
exports.initializeAppForSignup = async (context) => {

    const actions   = context.actions;
    const redux     = context.redux.hooks;
    const selectors = context.selectors.all;

    const {
        schoolId,
        verificationToken
    } = selectors.getSignupContext(redux.getState());

    if (schoolId) {
        await redux.dispatch(actions.dataFetching.fetchAppEntities({
            entities: [
                'interests',
                'schoolDetails',
                'badgeTypes',
                'yearsHired',
                'offices'
            ],
            schoolId,
            verificationToken
        }));
    }

    // This will trigger a redirect in the src/components/AppLoader.js component
    redux.dispatch(actions.app.setMainAppLoading({ appLoading: false }));
};
